export default __webpack_public_path__ + "static/B0146-7bcae038e19ac62461b7457b66fe2b60.png";